import uniq from 'lodash/uniq';

export const getVirusesList = data => {
  const names = data.flatMap(i => i.groups.map(d => d.key));

  return uniq(names);
};
